module.exports = __webpack_public_path__ + "media/10.5dfcbc61.mp3";